export default theme => ({
    root: {
        position: 'relative',
        minHeight: 'calc(100vh - 82px)',
        display: 'flex',
        flexDirection: 'column',
    },
})
